import { SUPPORT_URL } from '../../../integration-builder/utils/constants'

export const config = [
  {
    id: 1,
    title: 'Docs',
    children: [
      {
        title: 'Online',
        url: '/docs/online/',
      },
      {
        title: 'In-person',
        url: '/docs/in-person/',
      },
      {
        title: 'Multiparty',
        url: '/docs/multiparty/',
      },
      {
        title: '3rd-party',
        url: '/docs/3rd-party/',
      },
      {
        title: 'Payouts',
        url: '/docs/payouts/',
      },
      {
        title: 'Disputes',
        url: '/docs/disputes/',
      },
      {
        title: 'Reports',
        url: '/docs/reports/',
      },
      {
        title: 'Identity',
        url: '/docs/log-in-with-paypal/',
      },
      {
        title: 'Tracking',
        url: '/docs/tracking/',
      },
      {
        title: 'Docs archive',
        url: '/docs/archive/',
      },
    ],
  },
  {
    id: 2,
    title: 'APIs & SDKs',
    children: [
      {
        title: 'REST APIs',
        url: '/api/rest/',
      },
      {
        title: 'Server SDKs',
        url: '/serversdk/net-standard-library/getting-started/how-to-get-started/',
      },
      {
        title: 'JavaScript SDK',
        url: '/sdk/js/',
      },
      {
        title: 'Mobile SDKs',
        url: '/sdk/mobile/',
      },
      {
        title: 'NVP/SOAP APIs',
        url: '/api/nvp-soap/',
      },
      {
        title: 'Donate SDK',
        url: '/sdk/donate/',
      },
      {
        title: 'Braintree GraphQL API',
        url: '/braintree/graphql/',
      },
    ],
  },
  {
    id: 3,
    title: 'Tools',
    children: [
      {
        title: 'Upgrade hub',
        url: '/upgrade/',
      },
      {
        title: 'Agent toolkit',
        url: '/tools/agent-toolkit/',
      },
      {
        title: 'MCP server',
        url: '/tools/mcp-server/',
      },
      {
        title: 'VS Code extension',
        url: '/tools/vscode/',
      },
      {
        title: 'Sandbox testing guide',
        url: '/tools/sandbox/',
      },
      {
        title: 'Negative testing',
        url: '/tools/sandbox/negative-testing/',
      },
      {
        title: 'Credit card generator',
        url: '/tools/sandbox/card-testing/#link-testgeneratedcardnumbers',
      },
      {
        title: 'Demo portal',
        url: 'https://demo.paypal.com/home/',
      },
      {
        title: 'Webhooks',
        url: '/api/rest/webhooks/',
      },
      {
        title: 'Secure file transfer',
        url: '/tools/dropzone/',
      },
      {
        title: 'API status',
        url: 'https://www.paypal-status.com/api/production/',
      },
    ],
  },
  {
    id: 4,
    title: 'Community',
    children: [
      {
        title: 'Community home',
        url: '/community/home/',
      },
      {
        title: 'Blog',
        url: 'https://developer.paypal.com/community/blog/',
      },
      {
        title: 'Events',
        url: 'https://developer.paypal.com/community/events/',
      },
      {
        title: 'Champions',
        url: 'https://developer.paypal.com/community/champions/',
      },
      {
        title: 'Videos',
        url: 'https://developer.paypal.com/video/home/',
      },
      {
        title: 'Developer Program',
        url: 'https://developer.paypal.com/developer-program/',
      },
      {
        title: 'Referral Program',
        url: 'https://developer.paypal.com/community/referral-program/',
      },
    ],
  },
  {
    id: 5,
    title: 'Support',
    url: SUPPORT_URL,
  },
  {
    id: 6,
    title: 'PayPal.com',
    url: 'https://www.paypal.com',
  },
]
export const navLinks = [
  {
    id: 1,
    label: 'Docs',
    items: [
      {
        label: 'Online',
        url: '/docs/online/',
      },
      {
        label: 'In-person',
        url: '/docs/in-person/',
      },
      {
        label: 'Multiparty',
        url: '/docs/multiparty/',
      },
      {
        label: '3rd-party',
        url: '/docs/3rd-party/',
      },
      {
        label: 'Payouts',
        url: '/docs/payouts/',
      },
      {
        label: 'Disputes',
        url: '/docs/disputes/',
      },
      {
        label: 'Reports',
        url: '/docs/reports/',
      },
      {
        label: 'Identity',
        url: '/docs/log-in-with-paypal/',
      },
      {
        label: 'Tracking',
        url: '/docs/tracking/',
      },
      {
        label: 'Docs archive',
        url: '/docs/archive/',
      },
    ],
  },
  {
    id: 2,
    label: 'APIs & SDKs',
    items: [
      {
        label: 'REST APIs',
        url: '/api/rest/',
      },
      {
        label: 'Server SDKs',
        url: '/serversdk/net-standard-library/getting-started/how-to-get-started/',
      },
      {
        label: 'JavaScript SDK',
        url: '/sdk/js/',
      },
      {
        label: 'Mobile SDKs',
        url: '/sdk/mobile/',
      },
      {
        label: 'NVP/SOAP APIs',
        url: '/api/nvp-soap/',
      },
      {
        label: 'Donate SDK',
        url: '/sdk/donate/',
      },
      {
        label: 'Braintree GraphQL API',
        url: '/braintree/graphql/',
      },
    ],
  },
  {
    id: 3,
    label: 'Tools',
    items: [
      {
        label: 'Upgrade hub',
        url: '/upgrade/',
      },
      {
        label: 'Agent toolkit',
        url: '/tools/agent-toolkit/',
      },
      {
        label: 'MCP server',
        url: '/tools/mcp-server/',
      },
      {
        label: 'VS Code extension',
        url: '/tools/vscode/',
      },
      {
        label: 'Sandbox testing guide',
        url: '/tools/sandbox/',
      },
      {
        label: 'Negative testing',
        url: '/tools/sandbox/negative-testing/',
      },
      {
        label: 'Credit card generator',
        url: '/tools/sandbox/card-testing/#link-testgeneratedcardnumbers',
      },
      {
        label: 'Demo portal',
        url: 'https://demo.paypal.com/home/',
      },
      {
        label: 'Webhooks',
        url: '/api/rest/webhooks/',
      },
      {
        label: 'Secure file transfer',
        url: '/tools/dropzone/',
      },
      {
        label: 'API status',
        url: 'https://www.paypal-status.com/api/production/',
      },
    ],
  },
  {
    id: 4,
    label: 'Community',
    items: [
      {
        label: 'Community home',
        url: '/community/home/',
      },
      {
        label: 'Blog',
        url: 'https://developer.paypal.com/community/blog/',
      },
      {
        label: 'Events',
        url: 'https://developer.paypal.com/community/events/',
      },
      {
        label: 'Champions',
        url: 'https://developer.paypal.com/community/champions/',
      },
      {
        label: 'Videos',
        url: 'https://developer.paypal.com/video/home/',
      },
      {
        label: 'Developer Program',
        url: '/developer-program/',
      },
      {
        label: 'Referral Program',
        url: '/community/referral-program/',
      },
    ],
  },
  {
    id: 5,
    label: 'Support',
    url: SUPPORT_URL,
  },
  {
    id: 6,
    label: 'PayPal.com',
    url: 'https://www.paypal.com',
  },
]
